import type { Task, Activity, Matter } from "@/shared/cache";

export function renderTaskItem(item: Task) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">{item.task}</span>
      <span className="text-sm text-muted-foreground leading-tight truncate">
        {item.task_description}
      </span>
    </div>
  );
}

export function renderActivityItem(item: Activity) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">
        {item.activity}
      </span>
      <span className="text-sm text-muted-foreground leading-tight truncate">
        {item.activity_description}
      </span>
    </div>
  );
}

export function renderMatterItem(item: Matter) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">
        {item.matter.trim()}
      </span>
      <span className="text-sm text-muted-foreground leading-snug whitespace-normal break-words">
        {item.description.trim()}
      </span>
      <span className="text-xs text-muted-foreground/70 leading-tight truncate">
        {item.client.trim()}
      </span>
    </div>
  );
}

export function renderSelectedMatter(item: Matter) {
  return (
    <div className="flex flex-col py-0.5 min-w-0">
      <span className="text-sm font-semibold leading-tight truncate">
        {item.matter.trim()}
      </span>
      <span className="text-sm text-muted-foreground leading-snug truncate">
        {item.description.trim()}
      </span>
      <span className="text-xs text-muted-foreground/70 leading-tight truncate">
        {item.client.trim()}
      </span>
    </div>
  );
}
